import { t } from "i18next"
import { Number, Text } from "components/common"
import { useMemo } from "react"
import { IconText } from "components/custom"
import { List } from "antd"
import cx from "clsx"
import styles from "../index.module.less"
const CoreSummary = ({ data, onUnitsClick }) => {
  const coreData = useMemo(() => {
    return [
      [
        t("Flat Fee Sales"),
        <Number value={data?.totalSalesFlatFee} isCurrency={true} compact="" digitAfterFraction={2} />,
      ],
      [
        t("Marketing Fee Core"),
        <Number value={data?.totalMarketingFeeCore} isCurrency={true} compact="" digitAfterFraction={2} />,
      ],
      [t("Premium"), <Number value={data?.premium} isCurrency={true} compact="" digitAfterFraction={2} />],
      [t("Bonus"), <Number value={data?.bonus} isCurrency={true} compact="" digitAfterFraction={2} />],
      [t("Sales Tax"), <Number value={data?.totalTax} isCurrency={true} compact="" digitAfterFraction={2} />],
      [t("Total"), <Number value={data?.total} isCurrency={true} compact="" digitAfterFraction={2} />],
      [
        t("Invoiced Units"),
        <Number
          type="info"
          className="pointer bold text-underline"
          value={data?.invoicedUnitsCount}
          onClick={onUnitsClick}
          compact=""
        />,
      ],
    ]
  }, [data])
  return (
    <div className="pb-12" style={{ minHeight: 170 }}>
      <IconText
        title={t("Description of Services")}
        icon={"BsFileEarmarkText"}
        iconProps={{ style: { color: "#9D9D9D" }, hasBackground: true, size: "1em" }}
        gap={8}
        style={{ fontWeight: 600 }}
        className="mbe-12"
      />

      <List size="small" className={cx(styles.listingMain)}>
        {coreData?.map(e => (
          <List.Item>
            <div className="gray-700">{e[0]}</div>
            <div>{e[1]}</div>
          </List.Item>
        ))}
      </List>
    </div>
  )
}
export default CoreSummary
